<!--suppress HtmlUnknownTag -->
<template>
    <div>
      <b-table
          hoverable
          sticky-header
          v-slot="props"
          class="bordered-table"
          ref="leadDistributionTable"
          :data="data">
        <template v-if="windowWidth > 768">
          <b-table-column
              cell-class="cell" field="value" label="Name" width="650">
            <div class="distribution-set-title-wrapper">
              <span class="lead-distribution-set-title">{{ props.row.title }}</span>
              <span
                  class="lead-distribution-set-title-counter"> ({{props.row.leadSources.length}})
            </span>
            </div>
            <p>{{ leadSourcesInString(props.row) }}</p>
          </b-table-column>
        </template>
        <template v-else>
          <b-table-column
              cell-class="cell" field="value" label="Name" width="650">
            <div>
              <span class="lead-distribution-set-title">{{ props.row.title }}</span>
            </div>
          </b-table-column>
          <b-table-column
              cell-class="cell lead-source-column" field="value" label="Lead source" width="650">
            <p class="lead-source-column-content">{{ leadSourcesInString(props.row) }}
              <span class="lead-distribution-set-title-counter">
                ({{props.row.leadSources.length}})
              </span>
            </p>
          </b-table-column>
        </template>
        <b-table-column cell-class="cell lead-owner-column"
                        field="value" label="Lead owner" width="200">
          <div class="lead-owner-data-wrapper">
            <div class="lead-owner-info-wrapper">
              <div class="lead-owner-info"
                   v-for="owner in props.row.leadOwners" v-bind:key="owner.id">
              <span :class="{'gray-color':owner.percent === 0}">
                {{ owner.fullName }}
              </span>
                <span class="gray-color">
                ({{ owner.percent }}%)
              </span>
              </div>
            </div>
            <div class="not-distributed-wrapper">
              <span v-if="props.row.notDistributed !== 0">
                Not distributed
              </span>
              <span v-if="props.row.notDistributed !== 0 && props.row.notDistributed !== 100">
                ({{props.row.notDistributed}}%)
              </span>
            </div>
          </div>
        </b-table-column>
        <b-table-column class="cell lead-distribution-set-manage-column"
                        cell-class="action-data-column"
                        width="110" centered>
          <div class="actions-wrapper">
            <span class="icon is-success action-button" @click="onEditLeadOwner(props.row)">
                <i class="fas fa-user-alt fa-lg"></i>
            </span>
            <span class="icon is-success action-button" @click="onEditSet(props.row)">
                <i class="fas fa-pencil-alt fa-lg"></i>
            </span>
            <span class="icon is-success action-button" @click="onRemoveSet(props.row)">
                  <i class="far fa-trash-alt fa-lg"></i>
            </span>
          </div>
        </b-table-column>
      </b-table>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
import { getLeadSources, removeLeadDistribution } from '@/api/settings';
import Vue from 'vue';
import LeadDistributionModal from '@/components/Modal/LeadDistribution.vue';
import { search as getManagers } from '@/api/manager';
import * as MUTATIONS from '@/store/mutations';

export default {
  name: 'LeadDistribution',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(['hasAccess']),
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  created() {
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    ...mapMutations({
      startLoading: MUTATIONS.START_LOADING,
      finishLoading: MUTATIONS.FINISH_LOADING,
    }),
    resizeHandler(e) {
      this.windowWidth = e.target.innerWidth;
    },
    leadSourcesInString(row) {
      if (row.leadSources.length > 5) {
        let index = 0;
        const leadSources = [];
        while (index < 5) {
          leadSources.push(row.leadSources[index].leadSource);
          index += 1;
        }
        return `${leadSources.join(', ')}...`;
      }
      return row.leadSources.map((el) => el.leadSource).join(', ');
    },
    async onEditLeadOwner(row) {
      this.startLoading();

      try {
        const { data } = await getManagers({ orderBy: 'lastName' });
        row.leadOwners.forEach((elem) => {
          const idx = data.findIndex((item) => item.id === elem.id);
          data[idx].percent = elem.percent;
        });
        const Component = Vue.extend(LeadDistributionModal);
        await this.$buefy.modal.open({
          parent: this,
          component: Component,
          hasModalCard: true,
          trapFocus: true,
          scroll: 'keep',
          ariaModal: true,
          customClass: 'card-form-modal',
          canCancel: ['outside'],
          props: {
            data,
            leadDistributionSet: row,
            mode: 'leadDistributionOwner',
          },
          events: {
            submit(response) {
              const { context } = response;
              const vue = context.$parent.$parent;
              vue.$emit('submit');
            },
          },
        });
        this.changeModalPosition();
      } catch (error) {
        this.$buefy.snackbar.open({
          message: 'An unexpected error occurred, please contact support@enhancify.com',
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }

      this.finishLoading();
    },
    async onEditSet(row) {
      this.startLoading();

      try {
        const { data: { data } } = await getLeadSources();
        const Component = Vue.extend(LeadDistributionModal);
        await this.$buefy.modal.open({
          parent: this,
          component: Component,
          hasModalCard: true,
          trapFocus: true,
          scroll: 'keep',
          ariaModal: true,
          customClass: 'card-form-modal',
          canCancel: ['outside'],
          props: {
            data,
            leadDistributionSet: row,
            mode: 'leadDistributionSet',
          },
          events: {
            submit(response) {
              const { context } = response;
              const vue = context.$parent.$parent;
              vue.$emit('submit');
            },
          },
        });
        this.changeModalPosition();
      } catch (error) {
        this.$buefy.snackbar.open({
          message: 'An unexpected error occurred, please contact support@enhancify.com',
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }

      this.finishLoading();
    },
    async onRemoveSet(set) {
      await this.$buefy.dialog.confirm({
        title: 'Deleting lead distribution set',
        message: 'Are you sure you want to <b>delete</b> this lead distribution set? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        ariaModal: true,
        onConfirm: () => {
          this.loading = true;
          removeLeadDistribution(set.id).then((response) => {
            if (response.data.success) {
              this.$buefy.toast.open({
                message: 'Success',
                type: 'is-success',
                duration: 3000,
              });
            }
            this.$emit('submit');
          }).catch((error) => {
            this.$buefy.toast.open({
              message: _.get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
              type: 'is-danger',
              duration: 3000,
            });
          }).finally(() => { this.loading = false; });
        },
      });
      this.applyCustomStyle();
    },
    changeModalPosition() {
      const grid = document.querySelector('.grid-module');
      const modal = document.querySelector('.modal');
      if (grid && modal) grid.insertAdjacentElement('beforeend', modal);
    },
    applyCustomStyle() {
      const modalCardHeadTitle = document.querySelector('.modal .modal-card-head p.modal-card-title');
      modalCardHeadTitle.style.width = '100%';
    },
  },

};
</script>

<style lang="stylus" scoped>
.lead-owner-info
  white-space nowrap
.lead-source-column-content
  width 70%
.actions-wrapper
  display flex
  flex-wrap nowrap
  justify-content center
.lead-distribution-set-title
  font-weight bold
.lead-distribution-set-title-counter, .gray-color
  color rgba(0, 0, 0, 0.50)
.lead-owner-column
  vertical-align top
.not-distributed-wrapper
  color red
.lead-owner-info-wrapper
  margin-bottom 10px
.bordered-table
  td:first-child
    border-left 1px solid rgba(143, 167, 179, 0.3)
    vertical-align top
    .distribution-set-title-wrapper
      margin-bottom 5px
  td:last-child
    border-right 1px solid rgba(143, 167, 179, 0.3)
.bordered-table tbody td
  font-size 16px
.cell
  white-space inherit
.fix-size-button
  width 80px
  margin-bottom 8px
  margin-right 8px
.icon:not([class="icon is-large"])
  color #68ba62
  display inline-block
  margin 5px
.icon.action-button:hover
  color #23d160
.fa-pencil-alt, .fa-trash-alt, .fa-user-alt
  cursor pointer
.action-button
  display inline-block
  margin 0 .5rem
.b-table >>> .table-wrapper.has-sticky-header
  height 100%
  margin-bottom 20px
</style>
